import React from 'react';
import {get} from 'lodash';

import competencies from '/theme/competency';
import {asClassComponent} from '/util/hoc.util';

export default (Component: any) =>
  asClassComponent((props = {}) => {
    // @ts-expect-error TS(2339): Property 'theme' does not exist on type '{}'.
    const {theme = {}, competency} = props;
    const {competency: themeCompetency} = theme || {};

    // By default use the already resolved `competency` in `theme`.
    let resolvedCompetency = themeCompetency;

    // If a custom competency name is provided, then try to resolved the competency with the given
    // name from the `competencies` object in `theme`.
    if (competency) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      resolvedCompetency = competencies[competency];
    }

    // In any case, only use `resolvedCompetency` if it's not nil.
    if (resolvedCompetency) {
      const themeProps = {...theme, competency: resolvedCompetency};
      return (
        <Component
          {...props}
          theme={themeProps} // Deprecated: Use `getTheme` instead.
          getTheme={(...args: any[]) => get(themeProps, ...args)}
        />
      );
    } else {
      return <Component {...props} />;
    }
  });
